export const capitalizeFirstLetter = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

// get first two lines of text
export const getFirstTwoLines = (str: string) => {
  const lines = str.split('\n');
  return lines.slice(0, 2).join('\n');
};

export const isString = (value: unknown) => typeof value === 'string';

export const codeifyName = (name: string = '') =>
  name
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/&/g, 'and')
    .replace(/[^\w-]+/g, '');

export const buildProductTestId = (name: string, context?: string, suffix?: string): string => {
  const codified = codeifyName(name);
  const parts = ['product', context, codified, suffix].filter(Boolean);
  return parts.join('-');
};

/**
 * Global search input filter: keeps letters, digits, space, hyphen, apostrophe and &. Shared by
 * SearchScreen and the web header search (DIS-1907) so both send the same keywords.
 */
export const filterSearchText = (text: string) => text.replace(/[^0-9a-zA-Z- '&]/gi, '');

/**
 * DIS-1705: strips a hyphen that starts a search term, so `-196` is sent as `196`.
 * Assumption: MFL search reads a term-leading hyphen as "exclude". Not verified against MFL;
 * verified in prod that `196` returns the `-196` products.
 */
export const stripLeadingHyphens = (keywords: string) => keywords.replace(/(^|\s)-+/g, '$1');
